import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import Call from '../../components/Call';

const Intro = props => (
  <Layout bodyClass="page-contact">
    <SEO title="Contact" />
    <div className="intro intro-small">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Nau mai | Welcome</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Call button={false} />
        </div>


        <div className="col-12 pt-5 pb-6">
        Kia ora, welcome to OneAction Political Co-operative.

Aotearoa, the way we do politics is broken. I think it’s something most of us recognise, and when we look around the world it’s not hard to see that democracy is under threat.
<br></br> <br></br>
Traditional politics is focused on getting our vote, not empowering us. It aims to concentrate power in the hands of politicians and leave us out of the picture - at least until the next election.
 <br></br> <br></br>
Traditional politics creates division not unity. It revolves around short-term thinking, and views everything through a lens of political risk. It’s a broken model and it has taken us as far as it can.
<br></br> <br></br>
OneAction Political Co-op is a bit like a political party in that we seek seats in parliament. But we’re different in almost every other way...
<br></br> <br></br>
OneAction’s sole purpose is to give our members a voice in the decisions that shape Aotearoa.
<br></br> <br></br>
Us every day kiwis need to get a bit more involved in steering this great waka Aotearoa. OneAction is all about building an easy way to do just that - at massive scale.
<br></br> <br></br>
We aim to do this by building a digital democracy platform where our members participate in setting the views and values they want for New Zealand.
<br></br> <br></br>
In general elections we rely on votes from the co-op members not the public. In a sense, we vote for ourselves. OneAction won’t register as an official NZ political party until we have 200,000 members - enough to take seats at our first election.
<br></br> <br></br>
Our vision is that by 2032 OneAction will have the support of at least 500,000 New Zealanders, and that for our members, taking part in setting Aotearoa’s direction will be a fun and rewarding part of everyday life.
<br></br> <br></br>
We’re at stage 1 of our plan, which is just building support for the idea. Once we reach 25,000 members, we’ll move into the start-up stage.
<br></br> <br></br>
Would you support a better way of doing politics in Aotearoa? Click here to join us. It takes less than 2 minutes per month to support OneAction
<br></br> <br></br>
If you think it’s a good idea but do nothing, then a good idea is all it will ever be.
<br></br> <br></br>
Rhys Goodwin - Founder


        </div>
        {/* <div className="col-8">
          <h4 className="mt-4">Business Hours</h4>
          <table className="table table-sm opening-hours-table">
            <tbody>
              <tr>
                <td className="day font-weight-bold">Monday</td>
                <td className="opens">8:30am</td>
                <td>-</td>
                <td className="closes">5:00pm</td>
              </tr>
              <tr>
                <td className="day font-weight-bold">Tuesday</td>
                <td className="opens">8:30am</td>
                <td>-</td>
                <td className="closes">5:00pm</td>
              </tr>
              <tr>
                <td className="day font-weight-bold">Wednesday</td>
                <td className="opens">8:30am</td>
                <td>-</td>
                <td className="closes">5:00pm</td>
              </tr>
              <tr>
                <td className="day font-weight-bold">Thursday</td>
                <td className="opens">8:30am</td>
                <td>-</td>
                <td className="closes">5:00pm</td>
              </tr>
              <tr>
                <td className="day font-weight-bold">Friday</td>
                <td className="opens">8:30am</td>
                <td>-</td>
                <td className="closes">5:00pm</td>
              </tr>
              <tr>
                <td className="day font-weight-bold">Saturday</td>
                <td className="opens">Closed</td>
                <td />
                <td className="closes" />
              </tr>
              <tr>
                <td className="day font-weight-bold">Sunday</td>
                <td className="opens">Closed</td>
                <td />
                <td className="closes" />
              </tr>
            </tbody>
          </table>
        </div>*/}
      </div> 
    </div>
  </Layout>
);

export default Intro;
